import factory from './icon';
import Svg from './glyphs/LACY_logo.svg';

export default factory(Svg);
